import { navigate } from "vike/client/router"
import React from "react"
import Button from "aldoo-ra/Button"

function NotFoundPage() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-canvas via-neutral to-paper transition-colors">
      <div className="relative flex flex-col w-full min-h-screen items-center justify-center gap-[50px] px-4">
        {/* 404 image */}
        <img
          src="/static/images/404.png"
          alt="page not found"
          width="580px"
          height="326px"
          className="max-w-full h-auto"
        />
        <h1 className="text-text text-center font-bold text-xl">
          {`We couldn't find the page you're looking for`}
        </h1>
        <Button variant="admin_primary" onClick={() => navigate("/")}>
          {`Back to Home`}
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage